import React, {Component} from "react"
import PropTypes from "prop-types"

import withAuth from "@irati/auth/helpers/auth/withAuth"
import {H1} from "@irati/ui/src/Typography"
import Loading from "@irati/ui/src/Loading"
import {RECOGNITION} from "@irati/permissions/constants/products"
import authentication from "@irati/auth"
import {getPermissions} from "@irati/permissions/services/switchboard"

import {RewardPermission, RewardVisibility, SharingPermissions, PollCreation} from "./index"

export const ADMIN_ONLY = "ADMIN_ONLY"
export const ADMIN_AND_MANAGER = "ADMIN_AND_MANAGER"
export const EVERYONE = "EVERYONE"
export const OFF = "OFF"
export const ON = "ON"
export const LIMITED = "LIMITED"

const pollCreationOptions = [
  {value: ADMIN_ONLY, label: "admin.permissions.poll.adminOnly"},
  {value: ADMIN_AND_MANAGER, label: "admin.permissions.poll.adminAndManager"},
  {value: EVERYONE, label: "admin.permissions.poll.everyone"}
]

const recognitionSharingOptions = [...pollCreationOptions, {value: OFF, label: "admin.permissions.recognition.off"}]

const rewardVisibilityOptions = [
  {value: ON, label: "admin.permissions.reward.on"},
  {value: LIMITED, label: "admin.permissions.reward.limited"},
  {value: OFF, label: "admin.permissions.reward.off"}
]

class RecognitionSettings extends Component {
  static propTypes = {
    auth: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props)

    this.state = {
      sharing: null,
      createPoll: null,
      rewardView: null,
      attachReward: null,
      load: this.getRecognitionPermissions(props.auth.business)
    }
  }

  getRecognitionPermissions = (business) => {
    return getPermissions(business, RECOGNITION).then((productOptions) => {
      const {sharing, createPoll, rewardView, attachReward} = productOptions
      this.setState({
        sharing,
        createPoll,
        rewardView,
        attachReward
      })
    })
  }

  render() {
    const {sharing, createPoll, rewardView, attachReward, load} = this.state

    const isRewardDisabled = authentication.apps("recognition.recognition.isRewardDisabled")

    return (
      <>
        <H1 marginBottom={4}>Recognition</H1>
        <Loading load={load}>
          <SharingPermissions options={recognitionSharingOptions} value={sharing} />
          <PollCreation options={pollCreationOptions} value={createPoll} />
          {!isRewardDisabled && (
            <>
              <RewardVisibility options={rewardVisibilityOptions} value={rewardView} />
              <RewardPermission options={recognitionSharingOptions} value={attachReward} />
            </>
          )}
        </Loading>
      </>
    )
  }
}

export default withAuth(RecognitionSettings)
